import { render, staticRenderFns } from "./AccountAff.vue?vue&type=template&id=7364e45d&scoped=true"
import script from "./AccountAff.vue?vue&type=script&lang=js"
export * from "./AccountAff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7364e45d",
  null
  
)

export default component.exports